module.exports = __webpack_public_path__ + "20870ed3f4a3bccb3353edd66092ee32.svg";